'use strict';

class ListeResultat {
	constructor(config) {
		/// On surcharge {config} par {defaults}
		/// les propriétés de {defaults} ne sont ajoutées que si elles n'existent pas
		this.config = config
	}

	initialize() {

		/// Variables et variables en session
		sessionStorage.setItem('app', JSON.stringify({}));
		let self = this;

		/// On récupère les différentes classes et extension
		const utilities = new utilitiesListeResultat();
		const navMobile = new menuMobile();
		const filtres = new filtring();
		const datepicker = new calendrier();

		/// Présentation
		this.presentation(utilities);

		/// Avis
		this.getModale('avis');
		this.eventDataJs(document);
		utilities.showMore('#blockAvis', '.lr__more', 'is-overflow', false, {
			true: 'Lire la suite',
			false: 'Masquer'
		});

		window.addEventListener('hashchange', () => {
			self._locationHashChanged(utilities);
		}, false);

		/// Blocks Filtres et Résultats
		this.filtresResultats(false, filtres, datepicker);
		filtres.initialize();

		/// Menu Mobile
		let menuInitialized = false;
		navMobile.initialize(document.documentElement.clientWidth, menuInitialized);

		/// Blocks informations
		const blocksInfos = {
			'infosPratiques': document.getElementById('infosPratiques'),
			'expert': document.getElementById('expert')
		}
		this.information(blocksInfos, utilities);

		if (document.getElementById('moduleTelAgence')) {
			!require('common/helpers').isTouchDevice() && require('common/helpers').switchTelDesktop('moduleTelAgence');
			!require('common/helpers').isTouchDevice() && document.getElementById('moduleTelAgence').classList.add('module__link');
		}

		/// Navigation
		this.storePagination();

		/// Uniquement pour terdav.be
		settingsApp.app === 'TDV' && settingsApp.belge && commons.convertButtonToLink('data-voyage');

	}

	///
	/// Blocs filtres et resultats
	/// Fonction intermédiaire permettant de ne lancer que les fonctions liées aux filtres et aux circuits
	filtresResultats(isFiltered, filtring, calendrier) {
		let self = this;
		const getMoreResultats = new moreResultat();
		const utilities = new utilitiesListeResultat();

		/// Filtres
		document.getElementById('blockFiltresAutres') && self.popupFiltres(document.documentElement.clientWidth);
		let hasToggleFunction = false;
		document.querySelectorAll('[data-show]').forEach(el => {
			el.addEventListener('click', function () {
				self._modale('moreFiltres');
				!hasToggleFunction && utilities.showMore('#blockFiltresAutres', '.labelShowMore', 'is-overflow', true);
				hasToggleFunction = true;
			});
		});

		isFiltered && this.eventDataJs(document.getElementById('blockFiltre'));
		const calendarElement = document.getElementById('calendrier');
		calendrier.initialize(calendarElement, filtring);

		/// Pagination
		getMoreResultats.initialize();
	}

	///
	/// Bloc Présentation
	presentation(tools) {
		tools.showMore('.section--presentation', '.lr__more', 'is-overflow', true, {});

		/// Pour styler le contenu
		document.querySelectorAll('.section--presentation .bloc__descriptif p').forEach(el => {
			if (el.childElementCount === 1 && el.childNodes[0].localName === 'strong') {
				el.classList.add('intertitre')
			}
		})
	}

	scrollNext() {
		document.querySelector('.section--presentation').scrollIntoView({
			behavior: "smooth"
		})
	}

	toggleMap(e) {
		let showMap = false,
			display = 'none',
			btn = e.target
		if (btn === undefined) {
			btn = e;
			showMap = JSON.parse(sessionStorage.getItem('app')).mapState
		} else {
			showMap = JSON.parse(btn.dataset.map)
		}

		if (!showMap) {
			display = 'flex';
		}
		btn.dataset.map = !JSON.parse(showMap);
		if (JSON.parse(sessionStorage.getItem('app')) !== null) {
			let obj = JSON.parse(sessionStorage.getItem('app'));
			obj.mapState = showMap;
			sessionStorage.setItem('app', JSON.stringify(obj));
		}

		document.querySelectorAll('.circuit--carte').forEach(el => {
			if (el.querySelector('img').src === '') {
				el.querySelector('img').src = el.querySelector('img').dataset.urlCarte;
			}
			el.style.display = display;
		})
	}

	video(id) {
		let img = document.querySelector('#idVideoVimeo img'),
			idVideo = id === undefined ? img.dataset.videoId : id.target.dataset.videoId,
			optionsLightbox = {
				className: `lightbox--video`,
				onShow: () => {
					document.body.classList.add('lightbox--open');
				},
				onClose: () => {
					document.body.classList.remove('lightbox--open');
				}
			};


		settingsListeResultats.modules.moduleLightbox.then(() => {
			let moduleLightbox = require('modules/lib/basicLightbox.min');

			const templateInstance = moduleLightbox.create(document.querySelector(`[data-template='video']`), optionsLightbox);
			templateInstance.show();

			settingsListeResultats.modules.moduleVideo.then(() => {
				let moduleVideo = require('modules/video'),
					video = new moduleVideo();
				video.initialize(idVideo),
					infosVideo = JSON.parse(localStorage.getItem(`video-${idVideo}`));

				if (infosVideo != null) {
					document.querySelector(`.lightbox--video .video__titre`).innerHTML = infosVideo.title;
					document.querySelector(`.lightbox--video p`).innerHTML = infosVideo.description;
					document.querySelectorAll(`.lightbox--video [data-video-id]`).forEach((el) => {
						self.video(el.dataset.videoId)
					});
				}

				settingsListeResultats.modules.videoPlayerLib.then(() => {
					const player = video.playerVideo();
					video.thumbnailsVideo(player);
				});
			})
		});
	}

	_writeSchemaOrg(data, idVideo) {
		var el = document.createElement('script');
		el.type = 'application/ld+json';

		var iso8601Format = "PT" + Math.round(data.duration / 60) + "M" + data.duration % (Math.round(data.duration / 60) * 60) + "S";
		el.innerHTML = JSON.stringify({
			"@context": "https://schema.org",
			"@type": "VideoObject",
			"name": data.title,
			"description": data.description,
			"thumbnailUrl": [
				data.thumbnail_url
			],
			"duration": iso8601Format,
			"contentUrl": `https://player.vimeo.com/video/${idVideo}`
		});
		document.getElementById('idVideoVimeo').appendChild(el)
	}

	information(blocks, utilities) {
		if (document.getElementById('idVideoVimeo') != null) {

			let idVideo = document.getElementById('idVideoVimeo').dataset.videoId;
			settingsListeResultats.modules.moduleVideo.then(() => {
				let moduleVideo = require('modules/video'),
					video = new moduleVideo();
				video.initialize(idVideo, this._writeSchemaOrg);
			});
		}


		if (blocks.expert !== null) {
			utilities.showMore('#expert', '.lr__more', 'is-overflow', false, {
				true: 'Lire la suite',
				false: 'Masquer'
			});
		}

		if (blocks.infosPratiques !== null) {
			utilities.showMore('#infosPratiques', '.btn--toggle', 'is-overflow', true, {
				true: '+',
				false: 'X'
			});
		}
		if (document.querySelector('.section--avis .bloc [data-toggle="true"]') !== null) {
			utilities.showMore('.section--avis', '[data-toggle="true"]', 'is-overflow', true, {});
		}


		document.addEventListener('DOMContentLoaded', () => {
			document.querySelectorAll('.liste--linking').forEach((el) => {
				if (el.dataset.count !== undefined) {
					if (parseInt(el.dataset.count) > 2) {
						if (helpers.offset(el).height > 190) {
							el.classList.add('has-only-first-items-line-showed');
						} else {
							el.nextElementSibling.remove();
							el.classList.add('has-all-items-showed');
						}
					} else {
						el.nextElementSibling.remove();
					}

				}
			})
		})
	}

	// Méthode déplier/replier des box de linking
	showAllListe(el) {
		el.target.previousElementSibling.classList.toggle('has-only-first-items-line-showed');

		if ([...el.target.previousElementSibling.classList].includes('has-only-first-items-line-showed')) {
			el.target.previousElementSibling.scrollTop = 0;
			el.target.querySelector('use').setAttribute('xlink:href', '#picto-plus')
		} else {
			el.target.querySelector('use').setAttribute('xlink:href', '#icon-search-minus')
		}
	}


	////
	//// Modales
	getModale(type) {
		let self = this;

		let btns = document.querySelectorAll(`a[href="#${type}"]`);
		btns.forEach(el => {
			el.addEventListener('click', function (e) {
				e.preventDefault();
				self._modale(type);
			})
		});
	}

	_modale(libelle) {
		modalPopup.contentNotLoaded = true; /// Le contenu préexiste au lancement de la modale
		modalPopup.overrideStyles = false;
		modalPopup.items.popupModal = `[data-popup-modal="${libelle}"]`;

		modalPopup.reopen();
		if (libelle === 'moreFiltres') {
			document.documentElement.classList.remove('has-overlay');
			document.getElementById('blockFiltre').scrollIntoView();
			document.querySelectorAll('.box--filtre').forEach(el => el.hidden = true);
			setTimeout(() => {
				document.documentElement.classList.add('has--filtre-open');
			}, settingsListeResultats.delay)
		}

		if (document.querySelector(`[data-popup-modal="avis"]`) !== null) {
			document.querySelector(`[data-popup-modal="avis"] .popup-modal__close`).addEventListener('click', function (e) {
				e.preventDefault();
				document.body.classList.remove('has-overlay');
				history.pushState(null, document.title, location.pathname + location.search)
				document.querySelector(`[data-popup-modal="avis"]`).classList.remove('is--visible');
				document.querySelector('.body-blackout').classList.remove('is-blacked-out');
				document.getElementById('blockFiltre').classList.remove('is-down')
			});
		}
		if (document.querySelector(`[data-popup-modal="moreFiltres"]`) !== null) {
			document.querySelector(`[data-popup-modal="moreFiltres"] .popup-modal__close`).addEventListener('click', function (e) {
				document.documentElement.classList.remove('has--filtre-open');
				document.body.classList.remove('has-overlay');
				document.querySelector('.body-blackout').classList.remove('is-blacked-out');
				document.querySelector(`[data-popup-modal="moreFiltres"]`).classList.remove('is--visible');
			});
		}
		document.querySelector('.is-blacked-out').addEventListener('click', function (e) {
			history.pushState(null, document.title, location.pathname + location.search)
			document.documentElement.classList.remove('has--filtre-open');
			document.body.classList.remove('has-overlay');
			document.querySelector('.body-blackout').classList.remove('is-blacked-out');
			document.getElementById('blockFiltre').classList.remove('is-down');
			document.querySelector(`[data-popup-modal="avis"]`) !== null && document.querySelector(`[data-popup-modal="avis"]`).classList.remove('is--visible');
			document.querySelector(`[data-popup-modal="moreFiltres"]`) !== null && document.querySelector(`[data-popup-modal="moreFiltres"]`).classList.remove('is--visible');
		});
	}

	_locationHashChanged(tools) {
		if (tools.isHashed('#avis')) {
			this._modale(('avis'));
			document.getElementById('blockFiltre').classList.add('is-down')
		} else {
			document.getElementById('blockFiltre').classList.remove('is-down');
		}
	}

	////
	//// Avis
	getAvis() {
		var url = settingsListeResultats.lr.urlListeAvisClient;
		var indexNumeroPageAvisClient = document.getElementById('numeroPageAvisClient').value;
		var totalPageAvisClient = document.getElementById('totalPageAvisClient').value;

		if (typeof settingsListeResultats.lr.urlListeAvisClient === 'undefined')
			console.error('settingsListeResultats.lr.urlListeAvisClient est indéfinie');

		$.ajax({
			url: url,
			type: 'POST',
			data: {
				index: indexNumeroPageAvisClient
			},
			success: function (data) {
				indexNumeroPageAvisClient++;

				const avisList = document.getElementById('ListeAvisClient');
				const fragment = document.getElementById('listAvis');

				data.forEach(avis => {
					const instance = document.importNode(fragment.content, true);
					instance.querySelector('.avis__titre').innerHTML = avis.titre;

					if (avis.nomVoyage !== '') {
						instance.querySelector('.avis__voyage a').setAttribute('href', avis.urlProduit)
						instance.querySelector('.avis__voyage a').innerText = avis.nomVoyage;
					} else {
						instance.querySelector('.avis__voyage').remove();
					}

					instance.querySelector('.star-rating').style.setProperty('--percent', avis.note * 10 + '%');

					instance.querySelector('.avis__note').innerHTML = avis.note > 5 ? 'satisfait' : 'insatisfait';
					instance.querySelector('.avis__description').innerHTML = avis.avis;
					instance.querySelector('.avis__prenom').innerHTML = avis.prenom;

					instance.querySelector('.avis__date').innerHTML = avis.dateDepart;

					if (avis.reponse !== null) {
						instance.querySelector('.avis__reponse p').innerText = avis.reponse;
					} else {
						instance.querySelector('.avis__reponse').remove();
					}

					avisList.appendChild(instance);
				});

				if (indexNumeroPageAvisClient >= totalPageAvisClient)
					avisList.classList.add('is-complete');

				document.getElementById('numeroPageAvisClient').value = indexNumeroPageAvisClient;
			},
			error: function (err) {
				console.error(err)
			}
		});
	}

	eventDataJs(container) {
		let self = this,
			arr = container.querySelectorAll('[data-js]'),
			btnsAction = Array.from(arr)
			.filter(item => item.dataset.js !== 'getMoreResultat') /// le chargement des résultats via la pagination se fait dans resultat.js

		btnsAction.forEach(el => {
			el.addEventListener('click', function (e) {
				self[e.target.dataset.js](e);
			})
		});
	}

	popupFiltres(windowWidth) {

		const classes = ['popup-modal', 'popup-lr', 'popup-filtres'];
		let popup = document.getElementById('blockFiltresAutres');

		/// Création des éléments de la popup
		let btnClose = document.createElement('i');
		btnClose.className = 'popup-modal__close';

		let contentPopup = document.createElement('div');
		contentPopup.className = 'popup-content';

		let titlePopup = document.createElement('div');
		titlePopup.className = 'lr__titre popup-title';

		/// On attribut les classes et dataset aux différents éléments de la popup
		popup.classList.add(...classes);
		popup.dataset.popupModal = 'moreFiltres';

		/// On récupère le contenu
		let content = popup.innerHTML;
		popup.innerHTML = '';

		/// On injecte le titre, le contenu et le bouton de fermeture
		popup.appendChild(contentPopup);
		popup.prepend(btnClose);
		popup.prepend(titlePopup);
		popup.querySelector('.popup-content').innerHTML = content;
		titlePopup.textContent = 'Plus de filtres';
	}

	showFiltre(e) {
		document.querySelectorAll('.box--filtre').forEach(el => el.hidden = true);
		document.querySelectorAll('.popup-modal').forEach(el => el.classList.remove('is--visible'));
		e.target.nextElementSibling.hidden = false;
		document.querySelector('.body-blackout').classList.add('is-blacked-out');
		this.hideFiltre(e);

		document.getElementById('blockFiltre').scrollIntoView();

		setTimeout(() => {
			document.documentElement.classList.add('has--filtre-open');
		}, settingsListeResultats.delay)


		if (document.documentElement.clientWidth <= 1024) {
			e.target.scrollIntoView({
				behavior: "smooth",
				inline: "start"
			})
		}

	}

	hideFiltre(e) {
		document.querySelector('.body-blackout').addEventListener('click', function (el) {
			e.target.nextElementSibling.hidden = true;
			el.target.classList.remove('is-blacked-out');
			document.documentElement.classList.remove('has--filtre-open');
		});

		document.querySelectorAll('.close').forEach(el => {
			el.addEventListener('click', function () {
				e.target.nextElementSibling.hidden = true;
				document.documentElement.classList.remove('has--filtre-open');
				document.querySelector('.body-blackout').classList.remove('is-blacked-out');
			})
		})
	}



	/// Back Navigation
	storePagination() {
		if (window.sessionStorage.getItem('currentPage') === null) {
			window.sessionStorage.setItem('currentPage', window.location);
		}

		/// Je reviens sur la dernière liste de resultats consultée
		if (window.location.href === window.sessionStorage.getItem('currentPage')) {

			var numeroPageVoyage = window.sessionStorage.getItem('numeroPageVoyage');
			var url = settingsListeResultats.lr.ListeVoyages;
			var indexNumeroPageVoyage = 1;

			/// J'avais au moins chargé 20 + n circuits
			if (numeroPageVoyage > 1) {

				while (indexNumeroPageVoyage < numeroPageVoyage) {
					$.ajax({
						url: url,
						type: "POST",
						async: false,
						data: {
							index: indexNumeroPageVoyage
						},
						beforeSend: function () {
							document.body.classList.add('loading');
						},
						success: function (data) {
							$('#blockresults').append(data);
						},
						error: function (err) {
							document.location.reload(true);
						},
						complete: function () {

							// On met à jour les différents champs
							let nbreVoyagesTotal = settingsListeResultats.resultats.nbreVoyages;
							let nbreVoyagesAffiches = $('#nos-voyages .circuit').length;
							document.getElementById('nbreCircuitsAffiches').value = nbreVoyagesAffiches;
							settingsListeResultats.resultats.nbreVoyagesAffiches = nbreVoyagesAffiches;
							if (nbreVoyagesAffiches === nbreVoyagesTotal) {
								$('[data-js="getMoreResultat"]').hide();
								settingsListeResultats.resultats.showPagination = false;
							}

							document.body.classList.remove('loading');
						}
					});
					indexNumeroPageVoyage++;
					document.getElementById('numeroPageVoyage').value = numeroPageVoyage;
				}
			}
			/// J'étais resté sur le nombre de circuits initial
			else if (numeroPageVoyage === null) {
				/// Si je n'avais pas trié les résultats, je ne fais rien
				/// sinon je rappelle settingsListeResultats.lr.urlTrierListeResultats ///<%= Url.Action("TrierListeResultats","ListeResultats") %>
				if (window.sessionStorage.getItem('tri') !== null) {
					let tri = {
						typeTri: window.sessionStorage.getItem('tri')
					};

					$.ajax({
						url: settingsListeResultats.lr.urlTrierListeResultats,
						async: false,
						data: tri,
						type: "POST",
						dataType: "json",
						success: function (data) {
							if ('#nos-voyages' != '') {
								$('#nos-voyages').html(data);
							}
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.error(jqXHR, textStatus, errorThrown)
						},
						complete: function (url) {
							filtres.updateSettingsResultats(settingsListeResultats.lr.urlTrierListeResultats);
							window.sessionStorage.setItem('currentPage', window.location.href);
						}
					});
				}
			}
		} else if (window.location.href !== window.sessionStorage.getItem('currentPage')) {
			window.sessionStorage.setItem('tri', null);
			window.sessionStorage.setItem('numeroPageVoyage', null);
			window.sessionStorage.setItem('currentPage', window.location);

		} else {
			window.sessionStorage.setItem('currentPage', window.location);
		}
	}
}